var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-doc';
                    var viewUrl = 'gfx/sprite.svg#view-icon-doc';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 40',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };